import { Link } from '@tanstack/react-router';
import MobileNav from '@/components/react/MobileNav';
import { trackContactClick, trackSimulateClick } from '@/lib/analytics';

const navLinks = [
  { href: '#servicos', label: 'Serviços' },
  { href: '#como-funciona', label: 'Como Funciona' },
  { href: '#calculadora', label: 'Calculadora' },
  { href: '#sobre', label: 'Sobre' },
  { href: '#faq', label: 'FAQ' },
  { href: '/blog', label: 'Blog' },
];

export function Header() {
  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-neutral-200">
        <div className="container mx-auto px-4 lg:px-8">
          <nav className="flex items-center justify-between h-16 lg:h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 bg-navy-900 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">P</span>
              </div>
              <span className="text-xl font-bold text-navy-900">Patriar</span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                link.href.startsWith('/') ? (
                  <Link
                    key={link.href}
                    to={link.href}
                    className="text-neutral-600 hover:text-gold-600 transition-colors font-medium"
                  >
                    {link.label}
                  </Link>
                ) : (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={() => {
                      if (link.href === '#calculadora') trackSimulateClick('header_nav');
                    }}
                    className="text-neutral-600 hover:text-gold-600 transition-colors font-medium"
                  >
                    {link.label}
                  </a>
                )
              ))}
            </div>

            {/* Desktop CTA */}
            <div className="hidden md:flex items-center gap-4">
              <a
                href="#contato"
                onClick={() => trackContactClick('whatsapp', 'header')}
                className="inline-flex items-center justify-center rounded-lg bg-gold-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-gold-600 transition-colors"
              >
                Fale Conosco
              </a>
            </div>

            {/* Mobile Navigation */}
            <div className="md:hidden">
              <MobileNav navLinks={navLinks} />
            </div>
          </nav>
        </div>
      </header>

      {/* Spacer for fixed header */}
      <div className="h-16 lg:h-20"></div>
    </>
  );
}
